module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia4_thumb-8f253a8bc2e27dd2eb375004615fdc1d.jpg";